import ModalStore from "@src/stores/Component/ModalStore";
import required from "@libs/required";

class ProSignupFunnelModalStore extends ModalStore {
	constructor(rootStore) {
		super(rootStore, { maxWidth: "sm" });
		this.rootStore = rootStore;
	}

	get proSignupFunnelStore() {
		return this.rootStore.stores.proSignupFunnelStore;
	}

	setData({ service = required`service`, zipcode }) {
		super.setData("service", service);
		super.setData("zipcode", zipcode);
		this.show = true;
	}

	onClose() {
		this.show = false;
		this.proSignupFunnelStore.signupWithEmail = false;
	}
}

export default ProSignupFunnelModalStore;
